import { withInstall } from '@tw-element/utils'

import Card from './src/card.vue'

export const TwCard = withInstall(Card)
export default TwCard

export * from './src/card'
